import React from 'react';
import ConnectionModel, {
  ConnectionResponseType,
  ConnectionKind,
} from '@mm/state/model/ConnectionModel';
import PrimarySelect from '../../../../../../common/components/PrimarySelect/PrimarySelect';
import { RESPONSE_TYPE_OPTIONS } from '../constants';

type Props = {
  connection: ConnectionModel;
  onResponseTypeChange: (requestType: ConnectionResponseType) => void;
  customOptionsPosition?: 'top' | 'bottom';
};

const EditResponseType = ({
  connection,
  onResponseTypeChange,
  customOptionsPosition,
}: Props) => {
  const allResponseTypes = Object.values(RESPONSE_TYPE_OPTIONS);
  const filteredResponseTypes =
    connection.kind === ConnectionKind.AUDIENCE
      ? Object.values(RESPONSE_TYPE_OPTIONS).filter(
          responseType =>
            responseType.id !== ConnectionResponseType.MESSENGER_JSON,
        )
      : allResponseTypes;

  return (
    <>
      <div className="edit-connection-panel__title">
        What to do with JSON response
      </div>
      <PrimarySelect
        options={filteredResponseTypes}
        value={RESPONSE_TYPE_OPTIONS[connection.responseType]}
        onChange={responseType =>
          onResponseTypeChange(responseType.id as ConnectionResponseType)
        }
        customDropdownStyles={{ zIndex: '1000003' }}
        customOptionsPosition={customOptionsPosition}
      />
    </>
  );
};

export default EditResponseType;
